import React from 'react';

import styled from 'styled-components';
import * as S from './footer.styles';

function Footer(props) {
  const getCookie = cname => {
    if(typeof document !== 'undefined'){

    
    const name = cname + '=';
    const ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
  }
    return '';
  };

  const ccdeCookie = getCookie('ccde');

  return (
    <S.FooterMainWrap>
      <S.FooterInnerWrap>
        <S.FooterInnerMainWrap>
          <S.FooterRowWrap>
            <S.FooterContentWrap>
              <S.ListContentHead>
                <S.ListContentHeadText>MAKEMYTRIP</S.ListContentHeadText>
              </S.ListContentHead>
              <S.FooterContentList>
                <li>
                  <a href="https://www.makemytrip.com/about-us/company_profile.php" target="_blank">
                    About us
                  </a>
                </li>
                <li>
                  <a
                    href="https://investors.makemytrip.com/investors/overview/default.aspx"
                    target="_blank"
                  >
                    Investor Relations
                  </a>
                </li>
                {/* <li>
                  <a href="https://investors.makemytrip.com/investors/overview/default.aspx">Testimonials</a>
                </li> */}
                <li>
                  <a href="https://www.makemytrip.com/travel-guide/" target="_blank">
                    Travel Guide
                  </a>
                </li>
                <li>
                  <a href="https://www.makemytrip.com/blog/?intid=mmtblog_footer" target="_blank">
                    Travel Blog
                  </a>
                </li>
                <li>
                  <a href="https://www.makemytrip.com/mytripessentials/index.php" target="_blank">
                    My Trip Essentials
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.makemytrip.com/blog/?intid=Blog_HomePage_Tab_Stories"
                    target="_blank"
                  >
                    Stories
                  </a>
                </li>
                <li>
                  <a href="https://www.makemytrip.com/csr/mmt_foundation.html" target="_blank">
                    MMT Foundation
                  </a>
                </li>
                <li>
                  <a href="https://www.makemytrip.com/csr/csr_policy.html" target="_blank">
                    CSR Policy
                  </a>
                </li>
              </S.FooterContentList>
            </S.FooterContentWrap>
          </S.FooterRowWrap>
          <S.FooterRowWrap>
            <S.FooterContentWrap>
              <S.ListContentHead>
                <S.ListContentHeadText>ABOUT THE SITE</S.ListContentHeadText>
              </S.ListContentHead>
              <S.FooterContentList>
                <li>
                  {ccdeCookie === 'AE' ? (
                    <a href="/agent/contact-us/" target="_blank">
                      Contact Us
                    </a>
                  ) : (
                    <a href="https://www.makemytrip.com/support/contact-us.php" target="_blank">
                      Contact Us
                    </a>
                  )}
                </li>
                <li>
                  <a href="https://www.makemytrip.com/legal/payment_security.html" target="_blank">
                    Payment Security
                  </a>
                </li>
                <li>
                  <a href="/agent/privacy-policy/" target="_blank">
                    Privacy Policy
                  </a>
                </li>
                {ccdeCookie !== 'AE' && (
                  <li>
                    <a href="/agent/user-agreement/" target="_blank">
                      User Agreement
                    </a>
                  </li>
                )}
              </S.FooterContentList>
            </S.FooterContentWrap>
          </S.FooterRowWrap>
          <S.FooterRowWrap>
            <S.FooterContentWrap>
              <S.ListContentHead>
                <S.ListContentHeadText>PARTNER PROGRAMS</S.ListContentHeadText>
              </S.ListContentHead>
              <S.FooterContentList>
                <li>
                  <a href="https://www.makemytrip.com/support/branch-offices.php" target="_blank">
                    Our Retails Stores
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.makemytrip.com/franchisee/partner_with_us.php"
                    target="_blank"
                  >
                    Franchise Program Details
                  </a>
                </li>
                <li>
                  <a href="https://www.fxkart.com/makemytrip?utm_source=MMTAFF" target="_blank">
                    Foreign Exchange
                  </a>
                </li>
                <li>
                  <a href="https://www.makemytrip.com/hotels/hotelier-register.htm" target="_blank">
                    List your Hotel
                  </a>
                </li>
                <li>
                  <a href="https://www.makemytrip.com/" target="_blank">
                    MakeMyTrip
                  </a>
                </li>
                <li>
                  <a href="	https://www.redbus.com/" target="_blank">
                    Redbus
                  </a>
                </li>
                <li>
                  <a href="	https://www.goibibo.com/" target="_blank">
                    Goibibo
                  </a>
                </li>
              </S.FooterContentList>
            </S.FooterContentWrap>
          </S.FooterRowWrap>
        </S.FooterInnerMainWrap>
        <S.CopyRightText>
          &copy;{' ' + new Date().getFullYear() + ' MAKEMYTRIP PVT. LTD.'}
        </S.CopyRightText>
      </S.FooterInnerWrap>
    </S.FooterMainWrap>
  );
}

export default Footer;
